const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Podjetjetoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinarasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obvezno",
    },
  },
  salutation: {
    label: "Nagovor",
    placeholder: "Izberite nagovor",
    errors: {
      required: "Nagovor je obvezen",
      invalid: "Prosimo, izberite veljaven nagovor",
    },
  },
  firstName: {
    label: "Ime",
    placeholder: "Janez",
    errors: {
      required: "Ime je obvezno",
      minLength: "Ime mora biti dolgo vsaj 2 znaka",
      maxLength: "Ime je lahko dolgo največ 50 znakov",
    },
  },
  lastName: {
    label: "Priimek",
    placeholder: "Novak",
    errors: {
      required: "Priimek je obvezen",
      minLength: "Priimek mora biti dolg vsaj 2 znaka",
      maxLength: "Priimek je lahko dolg največ 50 znakov",
    },
  },
  email: {
    label: "E-pošta",
    placeholder: "janez.novak@primer.si",
    description:
      "Prosimo, vnesite osebni e-poštni naslov, ne skupnega e-poštnega naslova.",
    prefixWarningTitle: "Zaznan deljeni poštni predal",
    prefixWarningDescription:
      "Priporočamo uporabo osebnega e-poštnega naslova za boljšo in prilagojeno izkušnjo",
    errors: {
      required: "E-pošta je obvezna",
      invalidEmail: "Prosimo, vnesite veljaven e-poštni naslov",
      emailAssociatedWithYourAccount:
        "Vaš e-poštni naslov je povezan z vašim računom in ga ni mogoče spremeniti.",
    },
  },
  confirmEmail: {
    label: "Potrditev e-pošte",
    placeholder: "janez.novak@primer.si",
    errors: {
      required: "Potrditev e-pošte je obvezna",
      invalidEmail: "Prosimo, vnesite veljaven e-poštni naslov",
      emailMatchError: "E-poštna naslova se ne ujemata",
    },
  },
  password: {
    label: "Geslo",
    placeholder: "Vnesite svoje geslo",
    errors: {
      required: "Geslo je obvezno",
    },
  },
  confirmPassword: {
    label: "Potrditev gesla",
    placeholder: "Potrdite svoje geslo",
    errors: {
      required: "Potrditev gesla je obvezna",
      passwordMatchError: "Gesli se ne ujemata",
    },
  },
  addressLine1: {
    label: "Naslov vrstica 1",
    placeholder: "Slovenska cesta 123",
    errors: {
      required: "Naslov vrstica 1 je obvezen",
      minLength: "Naslov vrstica 1 mora biti dolg vsaj 5 znakov",
      maxLength: "Naslov vrstica 1 je lahko dolg največ 100 znakov",
    },
  },
  addressLine2: {
    label: "Naslov vrstica 2",
    placeholder: "Stanovanje 4B",
    errors: {
      required: "Naslov vrstica 2 je obvezen",
      maxLength: "Naslov vrstica 2 je lahko dolg največ 100 znakov",
    },
  },
  city: {
    label: "Mesto",
    placeholder: "Ljubljana",
    errors: {
      required: "Mesto je obvezno",
      minLength: "Mesto mora biti dolgo vsaj 2 znaka",
      maxLength: "Mesto je lahko dolgo največ 50 znakov",
    },
  },
  state: {
    label: "Država",
    placeholder: "Izberite državo",
    errors: {
      required: "Država je obvezna",
      invalid: "Prosimo, izberite veljavno državo",
    },
  },
  jurisdiction: {
    label: "Jurisdikcija licence",
    placeholder: "Izberite jurisdikcijo licence",
    errors: {
      required: "Jurisdikcija licence je obvezna",
      invalid: "Prosimo, izberite veljavno jurisdikcijo",
    },
  },
  zipCode: {
    label: "Poštna številka",
    placeholder: "1000",
    errors: {
      required: "Poštna številka je obvezna",
      invalid: "Prosimo, vnesite veljavno poštno številko",
    },
  },
  role: {
    label: "Vloga",
    placeholder: "Izberite svojo vlogo",
    errors: {
      required: "Prosimo, izberite svojo vlogo",
      invalid: "Prosimo, izberite veljavno vlogo",
    },
  },
  businessType: {
    label: "Vrsta podjetja",
    placeholder: "Izberite vrsto podjetja",
    errors: {
      required: "Vrsta podjetja je obvezna",
      invalid: "Prosimo, izberite veljavno vrsto podjetja",
    },
  },
  businessName: {
    label: "Ime podjetja",
    placeholder: "Vnesite ime podjetja",
    errors: {
      required: "Ime podjetja je obvezno",
      minLength: "Ime podjetja mora biti dolgo vsaj 2 znaka",
      maxLength: "Ime podjetja je lahko dolgo največ 100 znakov",
    },
  },
  businessSearch: {
    label: "Iskanje podjetja:",
    addNewAccount: "Dodaj nov poslovni račun",
    canNotFindBusiness: "Ne najdete svojega podjetja?",
    guideline:
      "Prosimo, vnesite svojo poštno številko in nato izberite s spodnjega seznama.",
    guidelineForNameSearch:
      "Prosimo, vnesite polno ime podjetja in nato izberite s seznama.",
    placeholder: "Kje delate?",
    noResults: "Ni najdenih rezultatov",
    searching: "Iskanje...",
    selectedBusinessHeading: "Izbrano podjetje:",
    selectedBusinessNotCorrect: "Ni pravilno?",
    selectedBusinessTryAgain: "Poskusite ponovno",
    selectedBusinessDismiss: "Zavrni podjetje",
    resultsFound: {
      singular: "Najdeno 1 podjetje",
      plural: "Najdeno več podjetij",
    },
    errors: {
      network:
        "Imamo težave pri povezovanju s storitvijo iskanja podjetij. Prosimo, poskusite ponovno pozneje.",
    },
  },
  explicitConsent: {
    label:
      "Z označitvijo tega polja se strinjam s pogoji uporabe Elanco in potrjujem, da bo Elanco zbiral in obdeloval moje osebne podatke v skladu s pravilnikom o zasebnosti Elanco",
    errors: {
      required: "Soglasje za e-pošto je obvezno",
    },
  },
  telephone: {
    label: "Osebni telefon",
    placeholder: "Vnesite svojo osebno telefonsko številko",
    dialCodeLabel: "Koda",
    dialCodePlaceholder: "Poišči državo…",
    errors: {
      invalid: "Prosimo, vnesite veljavno telefonsko številko.",
    },
  },
  businessTelephone: {
    label: "Poslovni telefon",
    placeholder: "Vnesite poslovno telefonsko številko",
    dialCodeLabel: "Koda",
    dialCodePlaceholder: "Poišči državo…",
    errors: {
      invalid: "Prosimo, vnesite veljavno telefonsko številko.",
    },
  },
  professionalNumber: {
    label: "Strokovna številka",
    placeholder: "1234567",
    errors: {
      required: "Prosimo, vnesite strokovno številko",
      maxLength: "Vnos presega omejitev znakov",
    },
  },
  addressSearch: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  businessSearchField: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  checkbox: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  checkboxGroup: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  combobox: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  datePicker: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  dateRange: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  dateTime: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  emailField: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  fileInput: {
    errors: {
      required: "Prosimo, izberite datoteko",
    },
  },
  number: {
    errors: {
      required: "Prosimo, vnesite številko",
      minValue: "Prosimo, vnesite vrednost, ki je večja od najnižje",
      maxValue: "Prosimo, vnesite vrednost, ki je manjša od najvišje",
    },
  },
  passwordField: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  rangeSlider: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  select: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  telephoneField: {
    errors: {
      required: "Prosimo, vnesite samo številke",
      invalidTelephone: "Prosimo, vnesite veljavno telefonsko številko",
      invalidFormat: "Neveljavna oblika številke",
    },
  },
  text: {
    errors: {
      required:
        "Prosimo, uporabljajte samo črke (A-Z), številke (0-9) in brez simbolov",
      maxLength: "Vnos presega omejitev znakov",
      minLength: "Vnos mora biti dolg vsaj 2 znaka",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "To polje je obvezno",
    },
  },
  form: {
    errors: {
      generic:
        "Pri pošiljanju obrazca je prišlo do napake. Prosimo, poskusite ponovno.",
      reportAnIssue: "Prosimo, sporočite težavo.",
      configuration: "Napaka pri konfiguraciji",
      noFormQuestionsAvailable: "Vprašanja v obrazcu niso na voljo.",
      formComponentLoad:
        "Komponente obrazca ni bilo mogoče naložiti zaradi nepodprtega polja.",
      code: "Koda",
      type: "Vrsta",
      missingRequiredFields:
        "V tem obrazcu manjkajo obvezna polja (E-pošta in/ali Soglasje). Prosimo, obrnite se na skrbnika, da popravi konfiguracijo obrazca.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Veterinar",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinar",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veterinar", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinar, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinaravustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinarasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinarasema - Veterinar",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinarasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinarasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinar",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Gospod",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Gospod",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Gospa",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Gospa/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
